import type { InjectionKey } from 'vue'

export const TAB_BAR_GROUP_NAME: InjectionKey<string> = Symbol('tabBarGroupName')
